import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import * as Objects from '@core/objects'

@Component({
    selector: 'core-custom-forms-helpers-search-filters-labels-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss']
})
export class CustomFormsHelpersSearchFiltersLabelsGroupComponent implements OnInit, OnChanges {


    @Input()  labels: Array<Objects.Label> = [];
    @Input()  selected: Array<Objects.Label> = [];
    @Output() choose = new EventEmitter<Objects.Label>();

    public placeholder: string = "Search tags in category";
    public input: string = "";
    public labelsFiltered: Array<Objects.Label> = [];

    public open: boolean = false;

    ngOnInit(): void {
        this.labelsFiltered = this.selected ? this.labels.filter((label: Objects.Label) => 
                        !this.selected.some((ls:Objects.Label) => ls.id === label.id)) : this.labels;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.selected){
            this.labelsFiltered = (this.selected && this.selected?.length) ? this.labels.filter((label: Objects.Label) => 
                !this.selected.some((ls:Objects.Label) => ls.id === label.id)) : this.labels;
        }
    }

    selectLabel(label: Objects.Label) {
        this.choose.emit(label);
    }

    onEnter(event) {
        event.preventDefault();
    }

}